import { FormInputState } from 'src_common/common/mobx-utils/Form2/FormInputState';
import { ReportKeyType } from 'src/components/Reports/ReportsFilter/ReportsFilterV2.state';
import { DateTime } from 'src_common/utils/time/time';

type FormType = 'restrainedRange' | 'unRestrainedRange' | 'filteredWithDate' | 'lastBetAfter' | 'grantedRange' | 'none';

export class ReportFormState {
    public dateStartForm: FormInputState<string, string>;
    public dateEndForm: FormInputState<string, string>;
    public claimedStartDateForm: FormInputState<string, string>;
    public claimedEndDateForm: FormInputState<string, string>;

    public constructor() {
        this.dateStartForm = FormInputState.new(DateTime.current().subtractDays(7).format('YYYY-MM-DD'));
        this.dateEndForm = FormInputState.new(DateTime.current().format('YYYY-MM-DD'));

        this.claimedStartDateForm = FormInputState.new(DateTime.current().subtractDays(7).format('YYYY-MM-DD'));
        this.claimedEndDateForm = FormInputState.new(DateTime.current().format('YYYY-MM-DD'));
    }

    public getFormType = (type: ReportKeyType | ''): FormType => {
        const restrainedRangeReports = [
            'client-openings',
            'statements',
            'mobile-returns',
            'in-play-returns',
            'gross-gambling-yield',
            'ggy-jurisdiction',
            'betting-levy',
            'payments',
            'bet-referral',
            'incomeaccess-accounts',
            'incomeaccess-sales',
            'affiliate-accounts',
            'affiliate-sales',
            'void-bets',
            'play-break',
            'isonis',
            'casino-report',
        ];

        if (restrainedRangeReports.includes(type)) {
            return 'restrainedRange';
        }

        const unRestrainedRangeReports = ['card-expiration', 'birthday-list', 'bonuses', 'credit-debit'];
        if (unRestrainedRangeReports.includes(type)) {
            return 'unRestrainedRange';
        }

        if (type === 'active-accounts') {
            return 'lastBetAfter';
        }

        if (type === 'freebets') {
            return 'grantedRange';
        }

        if (type === 'trading' || type === 'winners-and-losers') {
            return 'filteredWithDate';
        }

        // runReport without any filters
        return 'none';
    };
}
